import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import SubscriptionSection from '../components/SubscriptionSection';
import '../styles/History.css';
import heroBackground from '../assets/27.jpg';

const History = () => {
  const [activeSlide, setActiveSlide] = useState(1);
  const totalSlides = 3;

  const handlePrev = () => {
    setActiveSlide(prev => (prev === 1 ? totalSlides : prev - 1));
  };

  const handleNext = () => {
    setActiveSlide(prev => (prev === totalSlides ? 1 : prev + 1));
  };

  return (
    <div className="history-page">
      {/* Hero Banner */}
      <div className="hero-banner">
        <img 
          src={heroBackground} 
          alt="History Hero Banner" 
          className="hero-image"
        />
        
        {/* Overlay */}
        <div className="hero-overlay"></div>
        
        <div className="hero-content">
        </div>
      </div>
      
      {/* Main Content */}
      <section className="main-content">
        <div className="container">
          <h1 className="section-title">
            LỊCH SỬ PHÁT TRIỂN
          </h1>
          
          {/* Quote Box */}
          <div className="quote-container">
            <div className="quote-box">
              <div className="quote-mark-left">"</div>
              <div className="quote-mark-right">"</div>
              <p className="quote-text">
              Với tinh thần đổi mới không ngừng, Phúc An Solutions luôn tiên phong tìm kiếm những giải pháp hiện đại và hiệu quả nhất, đặt sự hài lòng của khách hàng làm kim chỉ nam cho mọi hành động.
              </p>
            </div>
          </div>
          
          {/* Timeline Content */}
          <div className="timeline-wrapper">
            {/* Desktop Timeline */}
            <div className="desktop-timeline">
              <div className="timeline-grid">
                {/* 2023 Content - Left Side */}
                <div className="timeline-left">
                  <h2 className="year-title">2023</h2>
                  <div className="year-content">
                    <p className="year-text">
                    Phúc An tiền thân là một công ty về công nghệ thông tin hoạt động từ năm 2022, trụ sở chính tại P. Hưng Long, TX. Chơn Thành, Bình Phước; về sau, được dời trụ sở về 432 Nguyễn Huệ, P Phú Thịnh, TX. Bình Long, Bình Phước và tiếp tục đi vào hoạt động từ ngày 6 tháng 10 năm 2023, với tên gọi đầy đủ là Công ty TNHH Phúc An Solutions.
                    </p>
                  </div>
                </div>
                
                {/* Center Image */}
                <div className="timeline-center">
                  <div className="center-image">
                    <img 
                      src="/images/5.jpg" 
                      alt="Phúc An Office 2023"
                    />
                  </div>
                </div>
                
                {/* 2025 Content - Right Side */}
                <div className="timeline-right">
                  <h2 className="year-title">2025</h2>
                  <div className="year-content">
                    <p className="year-text">
                      Ngày 12/1/2025, Phúc An khai trương văn phòng điều hành mới tại số 351 Nguyễn Huệ, P. An Lộc, TX. Bình Long, Bình Phước. Đây được xem là cột mốc quan trọng đánh dấu bước chuyển mình mạnh mẽ của Phúc An.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Mobile/Tablet Timeline */}
            <div className="mobile-timeline">
              {/* 2023 */}
              <div className="mobile-year-section">
                <h2 className="mobile-year-title">2023</h2>
                <div className="mobile-year-image">
                  <img 
                    src="/images/Rectangle31.png" 
                    alt="Phúc An Office 2023"
                  />
                </div>
                <p className="mobile-year-text">
                  Phúc An tiền thân là một công ty về công nghệ thông tin hoạt động từ năm 2022, trụ sở chính tại P. Hưng Long, TX. Chơn Thành, Bình Phước; về sau, được dời trụ sở về 432 Nguyễn Huệ, P Phú Thịnh, TX. Bình Long, Bình Phước và tiếp tục đi vào hoạt động từ ngày 6 tháng 10 năm 2023, với tên gọi đầy đủ là Công ty TNHH Phúc An Solutions.
                </p>
              </div>

              {/* 2025 */}
              <div className="mobile-year-section">
                <h2 className="mobile-year-title">2025</h2>
                <p className="mobile-year-text">
                  Ngày 12/1/2025, Phúc An khai trương văn phòng điều hành mới tại số 351 Nguyễn Huệ, P. An Lộc, TX. Bình Long, Bình Phước. Đây được xem là cột mốc quan trọng đánh dấu bước chuyển mình mạnh mẽ của Phúc An.
                </p>
              </div>
            </div>
            
            {/* Timeline Bar */}
            <div className="timeline-bar">
              {/* Timeline Line */}
              <div className="timeline-line-bg"></div>
              
              {/* Timeline Navigation */}
              <div className="timeline-nav">
                <button 
                  onClick={handlePrev}
                  className="nav-button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M15 18l-6-6 6-6" />
                  </svg>
                </button>
                
                {/* Timeline Dots */}
                <div className="timeline-dots">
                  <div className={`timeline-dot ${activeSlide === 1 ? 'active' : ''}`}></div>
                  <div className={`timeline-dot ${activeSlide === 2 ? 'active' : ''}`}></div>
                  <div className={`timeline-dot ${activeSlide === 3 ? 'active' : ''}`}></div>
                </div>
                
                <button 
                  onClick={handleNext}
                  className="nav-button"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </button>
              </div>
            </div>
            
            {/* Bottom Content - 2024 */}
            <div className="bottom-content">
              {/* Desktop Layout */}
              <div className="desktop-2024">
                {/* Left Image */}
                <div className="bottom-left">
                  <div className="bottom-image">
                    <img 
                      src="/images/4.jpg" 
                      alt="Year 2024"
                    />
                  </div>
                </div>
                
                {/* 2024 Content */}
                <div className="bottom-center">
                  <h2 className="bottom-year-title">2024</h2>
                  <div className="bottom-text">
                    <p>
                      Xuất phát điểm là một cửa hàng kinh doanh điện tử - công nghệ nhỏ lẻ, chuyên cung cấp giải pháp công nghệ thông tin và hệ thống CCTV.
                    </p>
                    <p>
                      Tháng 3/2024, thành lập văn phòng điều hành tại địa chỉ 34 Hùng Vương, P. Phú Thịnh, TX. Bình Long, Bình Phước.
                    </p>
                    <p>
                      Tháng 4/2024, Phúc An chính thức trở thành công ty tư nhân đa nền tảng đầu tiên tại Bình Phước.
                    </p>
                  </div>
                </div>
                
                {/* Right Image */}
                <div className="bottom-right">
                  <div className="bottom-image">
                    <img 
                      src="/images/company.jpg" 
                      alt="Phúc An Team"
                    />
                  </div>
                </div>
              </div>

              {/* Mobile/Tablet Layout */}
              <div className="mobile-2024">
                <h2 className="mobile-bottom-year-title">2024</h2>
                
                <div className="mobile-images">
                  <div className="mobile-bottom-image">
                    <img 
                      src="/images/Rectangle29.png" 
                      alt="Year 2024"
                    />
                  </div>
                  <div className="mobile-bottom-image">
                    <img 
                      src="/images/Rectangle30.png" 
                      alt="Phúc An Team"
                    />
                  </div>
                </div>
                
                <div className="mobile-bottom-text">
                  <p>
                    Xuất phát điểm là một cửa hàng kinh doanh điện tử - công nghệ nhỏ lẻ, chuyên cung cấp giải pháp công nghệ thông tin và hệ thống CCTV.
                  </p>
                  <p>
                    Tháng 3/2024, thành lập văn phòng điều hành tại địa chỉ 34 Hùng Vương, P. Phú Thịnh, TX. Bình Long, Bình Phước.
                  </p>
                  <p>
                    Tháng 4/2024, Phúc An chính thức trở thành công ty tư nhân đa nền tảng đầu tiên tại Bình Phước.
                  </p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Video Section */}
          <div className="video-section">
          <div className="video-wrapper">
                <iframe
                  src="https://www.youtube.com/embed/6wN6ATHNAPo"
                  title="Phúc An Solutions - Video Giới Thiệu"
                  className="video-iframe"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
          
        
        {/* Team Image - Full Width */}
        <div className="team-section">
          <div className="team-image">
            <img 
              src="/images/company.jpg" 
              alt="Phúc An Solutions Team"
            />
          </div>
        </div>
      </section>
      
      {/* Subscription Section */}
      <SubscriptionSection />
    </div>
  );
};

export default History; 